<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  font: 12px/1.5 simhei, tahoma, arial, simsun;
}
#app {
  width: 19.2rem;
  margin: 0 auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>
